import { Questionaire } from "@/domain/entities/Questionaire";
import { IQuestionaireRepository } from "@/domain/repositories/IQuestionaireRepository";
import { IShowQuestionaireUseCase } from "@/domain/usecases/IShowQuestionaireUseCase";

export class ShowQuestionaireUseCase implements IShowQuestionaireUseCase {
    repository: IQuestionaireRepository
    constructor(repository: IQuestionaireRepository) {
        this.repository = repository
    }

    execute(id: string): Promise<Questionaire> {
        return this.repository.show(id)
    }
}
